import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import TevelCyberLogo from "../../../assets/img/TevelCyberFinalBlueLogo.png";
import UserService from "../../../services/UserService";
import AlertService from "../../../services/AlertService";
import CyberBay from "../../../assets/img/CyberBayFinalBlueLogo.png";
import LoginImage from "../../../assets/img/LoginIllustraion.png";
import EmailIcon from "../../../assets/icons/EmailIcon.svg";

const Forgot = () => {
  const [emailIsValid, setEmailIsValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const captchaControllerRef = useRef(null);
  const submitControllerRef = useRef(null);
  const navigate = useNavigate();

  const emailRef = useRef();
 const onCaptchaChange = async (response) => {
  if (captchaControllerRef.current) {
    captchaControllerRef.current.abort();
  }
  const controller = new AbortController();
  captchaControllerRef.current = controller;

  setLoading(true);

  try {
    const data = await UserService.ValidateReCaptcha(
      response,
      controller.signal
    );

    if (controller.signal.aborted) return;

    const isCaptchaValid = data?.isSuccess ?? data?.data ?? false;
    setIsValid(isCaptchaValid);
  } catch (err) {
    if (err.name === "AbortError") return;
    console.error("Captcha validation failed:", err);
    setIsValid(false);
  } finally {
    if (!controller.signal.aborted) setLoading(false);
  }
};

 const onSubmitHandler = async (event) => {
  event.preventDefault();
  const emailValue = emailRef.current.value;

  if (!emailValue) {
    setEmailIsValid(false);
    return;
  }

  if (!emailIsValid) return;

  if (submitControllerRef.current) {
    submitControllerRef.current.abort();
  }
  const controller = new AbortController();
  submitControllerRef.current = controller;

  setLoading(true);

  try {
    const result = await UserService.ForgotPassword(
      emailValue,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (result.isSuccess) {
      AlertService.success(
        "A link to reset the password is sent to your email successfully!"
      );
      navigate("/login");
    } else {
      AlertService.error(result.errorMessage);
    }
  } catch (ex) {
    if (ex.name === "AbortError") return;
    console.log(ex);
  } finally {
    if (!controller.signal.aborted) setLoading(false);
  }
};

useEffect(() => {
  return () => {
    captchaControllerRef.current?.abort();
    submitControllerRef.current?.abort();
  };
}, []);

  return (
    <div className="container-fluid min-vh-100 d-flex flex-column flex-xl-row p-0">
      {/* Left Section */}
      {/* Desktop Logo */}
      <div className="col-xl-6 d-flex flex-column justify-content-center align-items-center p-3 p-lg-5 min-vh-100  ">
        <div className="d-none d-xl-block">
          <img
            src={TevelCyberLogo}
            alt="Company Logo"
            style={{ maxWidth: "217px", marginRight: "220px" }}
            className="img-fluid"
          />
        </div>
        {/* Full Height Flex to Center Logos + Form */}
        <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100">
          <div className="d-flex d-xl-none justify-content-between align-items-center gap-5 mt-3 mb-4">
            <img
              src={TevelCyberLogo}
              alt="Tevel Cyber Logo"
              className="img-fluid"
              style={{ width: "140px" }}
            />
            <img
              src={CyberBay}
              alt="Cyber Bay Logo"
              className="img-fluid"
              style={{ width: "120px" }}
            />
          </div>
          {/* Form Block */}
          <div className="w-100 mb-xl-4" style={{ maxWidth: "454px" }}>
            <h4 className="mb-2  text-center text-xl-start fw-bold">
              Forgot Password
            </h4>
            <p className="mb-4 text-center text-xl-start">
              Don’t worry, we’ll reset your password and send you a link to
              create a new one.
            </p>

            <form onSubmit={onSubmitHandler}>
              <div className="mb-4">
                <div className="input-group">
                  <span className="input-group-text bg-transparent border-end-0">
                    <img src={EmailIcon} alt="emailIcon" />
                  </span>
                  <input
                    type="email"
                    id="email"
                    className="form-control border-start-0 custom-input"
                    placeholder="Email"
                    style={{ paddingLeft: "5px" }}
                    ref={emailRef}
                    onChange={() => setEmailIsValid(true)}
                  />
                </div>
                {!emailIsValid && (
                  <small className="text-danger">Please enter your email</small>
                )}
              </div>
              <div
                style={{
                  width: "454px",
                  height: "90px",
                  transform: "scale(1.493, 1.154)",
                  transformOrigin: "0 0",
                  overflow: "hidden",
                }}
              >
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_SITEKEY}
                  onChange={onCaptchaChange}
                />
              </div>
              <div className="d-flex justify-content-between mt-4">
                <button
                  type="button"
                  className="btn text-decoration-none btn-outline-login custom-input"
                  onClick={() => navigate("/login")}
                  disabled={loading}
                  style={{ maxWidth: "180px" }}
                >
                  Back to Login
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-4 custom-input"
                  disabled={loading || !isValid}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : null}
                  {loading ? "Sending..." : "Send reset link"}
                </button>
              </div>
            </form>
          </div>
        </div>
        <footer className="mt-auto text-center w-100">
          <p className="text-muted small mb-0">
            © 2026 Tevel Cyber Corps Pvt. Ltd. All rights reserved - Version 2.2.0
          </p>
        </footer>
      </div>

      {/* Right Section */}
      <div className="col-xl-6 d-none d-xl-flex flex-column login-bg  min-vh-100 align-items-center justify-content-center  ">
        <div className="p-5 mt-2">
          <img
            src={CyberBay}
            alt="CYBER BAY"
            className="img-fluid mb-4"
            width="130px"
          />
        </div>
        <div className='"d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100 p-xl-5'>
          <img
            src={LoginImage}
            alt="Decorative"
            className="img-fluid loginImg"
            style={{
              maxWidth: "690px",
              maxHeight: "484px",
              marginLeft: "130px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Forgot;
